import { Injectable, inject } from '@angular/core';
import { Configuration } from '../shared/configuration/configuration';

@Injectable({ providedIn: 'root' })
export class ProxyService {
  private readonly config = inject(Configuration);

  private get proxyBase(): string {
    return this.config.proxyUrl.replace(/\/+$/, '');
  }

  proxyUrl(target: string): string {
    return `${this.proxyBase}${encodeURIComponent(target)}`;
  }

  belongsToApi(url: string): boolean {
    const api = this.config.apiUrl.replace(/\/+$/, '');
    return url.startsWith(api);
  }
}
